import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, ControlLabel, FormControl,
  HelpBlock, Popover, OverlayTrigger, Collapse, Panel, PanelGroup } from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';

import {
  find, first, each, some, omit, reduce,
} from 'lodash';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError, formValueSelector, getFormValues } from 'redux-form';
import NumberFormat from 'react-number-format';
// Import Actions
import { requestAddOrganization, requestUpdateOrganization } from '../../AdminActions';
import { getUser } from '../../../Auth/AuthReducer';
import ConfirmButton from '../../../../components/confirm-button';
import AuditLog from '../../../../components/audit-logs';

import styles from './styles.css';

import { allContactGDPROptions, allSalesRepGDPROptions } from '../../../../util/helpers';
import { requestAddOrganizationUser } from '../../../Setup/SetupActions';

class AddOrganizationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showForm,
      openSpecialUserIdPanel: false,
      activeKey: null,
    };
    this.onToggleTier = this.onToggleTier.bind(this);
    this.onToggleSyncing = this.onToggleSyncing.bind(this);
    this.onToggleThrottle = this.onToggleThrottle.bind(this);
    this.onToggleManualSync = this.onToggleManualSync.bind(this);
    this.onToggleSyncType = this.onToggleSyncType.bind(this);
    this.onToggleAutoEmail = this.onToggleAutoEmail.bind(this);

    this.onToggleSellerReasons = this.onToggleSellerReasons.bind(this);
    this.onToggleSellerReasonsFirst = this.onToggleSellerReasonsFirst.bind(this);

    this.onToggleView = this.onToggleView.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.selectContactGDPR = this.selectContactGDPR.bind(this);
    this.selectSalesRepGDPR = this.selectSalesRepGDPR.bind(this);
    this.onToggleGroupView = this.onToggleGroupView.bind(this);
    this.handlePanelSelect = this.handlePanelSelect.bind(this);
    this.onToggleOrganizationStatus = this.onToggleOrganizationStatus.bind(this);
    this.onToggleExportCrmUrls = this.onToggleExportCrmUrls.bind(this);
    this.confirmChange = this.confirmChange.bind(this);
    if (props.showForm) {
      this.open();
    }
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onToggleTier() {
    const { tier } = this.props;
    this.props.change('tier', tier === 'basic' ? 'premium' : 'basic');
  }

  onToggleSyncing() {
    const { syncing } = this.props;
    this.props.change('syncing', !syncing);
  }

  onToggleThrottle() {
    const { selectedBypassRequestFeedbackThrottle } = this.props;
    this.props.change('bypass_request_feedback_throttle', !selectedBypassRequestFeedbackThrottle);
  }

  onToggleManualSync() {
    const { selectedManualSync } = this.props;
    this.props.change('manual_sync', !selectedManualSync);
  }

  onToggleSyncType() {
    const { syncType } = this.props;
    this.props.change('sync_type', syncType === 'detailed' ? 'summary' : 'detailed');
  }

  onToggleOrganizationStatus() {
    const { selectedEnabled } = this.props;
    this.props.change('enabled', !(selectedEnabled === true));
  }

  onToggleAutoEmail() {
    const { autoEmail } = this.props;
    this.props.change('auto_send_welcome_email', !autoEmail);
  }

  onToggleSellerReasons() {
    const { sellerReasonsEnabled } = this.props;
    this.props.change('seller_reasons_enabled', !sellerReasonsEnabled);
    if (!sellerReasonsEnabled) {
      this.props.change('seller_reasons_first', false);
      this.props.change('seller_reasons_public', false);
    }
  }

  onToggleSellerReasonsFirst() {
    const { sellerReasonsFirst } = this.props;
    this.props.change('seller_reasons_first', !sellerReasonsFirst);
  }

  onToggleView(view) {
    const { selectedFeatures, submitting } = this.props;
    if (!submitting) {
      const currentVal = selectedFeatures[view];
      this.props.change(`features.${view}`, !currentVal);
    }
  }

  onToggleGroupView(views) {
    const { selectedFeatures, submitting } = this.props;
    if (!submitting) {
      const hasSomeSelected = some(views, ({ key }) => selectedFeatures[key]);
      each(views, ({ key }) => this.props.change(`features.${key}`, !hasSomeSelected));
    }
  }

  selectContactGDPR(v) {
    this.props.change('contact_gdpr_compliance', v);
  }

  selectSalesRepGDPR(v) {
    this.props.change('sales_rep_gdpr_compliance', v);
  }

  onToggleExportCrmUrls() {
    const { selectedExportCrmUrls } = this.props;
    this.props.change('export_crm_urls', !selectedExportCrmUrls);
  }

  handlePanelSelect(activeKey) {
    this.setState({ activeKey });
  }

  close() {
    if (this.mounted) {
      this.props.reset();
      this.props.onModalClose();
      this.setState({ showModal: false, openSpecialUserIdPanel: false });
    }
  }

  open() {
    const data = { ...this.props.organization };
    if (!data._id) {
      // new record
      if (!data.features) {
        data.features = {};
      }
      const defaultViews = ['buyer_decisions', 'outcomes', 'performance', 'progress_dashboard'];
      each(defaultViews, (defaultView) => {
        data.features[defaultView] = true;
      });
      data.search_limit = 5000;
      data.bypass_request_feedback_throttle = true;
      data.mail_service = 'postmark';
      data.export_crm_urls = false;
    }
    this.props.initialize(data);
    this.setState({ showModal: true, openSpecialUserIdPanel: false });
  }

  confirmChange() {
    const { formValues, organization, handleSubmit } = this.props;
    const data = {
      ...formValues,
      organization_id: organization.organization_id,
    };
    handleSubmit(this.handleSubmit)(data);
  }

  handleSubmit(data) {
    const { organization } = this.props;
    const isNew = organization._id === undefined;

    if (data.sync_limit) {
      data.sync_limit = parseInt(data.sync_limit, 10);
    }

    const action = isNew ? requestAddOrganization(data) : requestUpdateOrganization(organization._id, data);

    return this.props.dispatch(action)
      .then(
        (updatedOrganization) => {
          if (isNew) {
            this.props.onAdd(updatedOrganization);
            // will move this to BE
            /*
            // Create a generic integration user for a new org.
            const integrationUser = this.createIntegrationUser(updatedOrganization.organization);
            const { _id } = updatedOrganization.organization;
            this.props.dispatch(requestAddOrganizationUser(_id, integrationUser));
            */
          } else {
            this.props.onUpdate(updatedOrganization);
          }
          this.close();
        },
        (errors) => {
          throw new SubmissionError(errors.data || errors);
        },
      );
  }

  createIntegrationUser(organization) {
    return {
      first_name: 'Integration',
      last_name: 'User',
      email: `${(organization.display_name || '').split(' ').join('').toLowerCase()}.integration.user@trusales.com`,
      is_none_standard_user: false,
      is_synchronization_user: true,
      organization_role: "admin",
      role: "user",
    };
  }

  renderField({
    input, label, type, options, meta: { touched, error }, componentClass, placeholder,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}:</ControlLabel>}
        {componentClass === 'number' &&
          <NumberFormat
            className="form-control"
            thousandSeparator
            {...omit(input, ['onChange', 'onBlur'])}
            disabled={submitting}
            decimalScale={0}
            placeholder={(placeholder || label)}
            allowNegative={false}
            onValueChange={(v) => {
              this.props.change(input.name, v.floatValue || null);
            }}
          />
        }
        {componentClass === 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            type={type}
            disabled={submitting}
          >
            <option />
            {options.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
          </FormControl>
        }
        {componentClass !== 'number' && componentClass !== 'select' && <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={submitting} />}
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderViewPermissions() {
    const { selectedFeatures, submitting } = this.props;
    const cursor = submitting ? 'not-allowed' : 'pointer';
    const feedbackChildren = [
      { key: 'buyer_decisions', label: 'Buyer Decisions' },
      { key: 'customer_experience', label: 'Customer Experience' },
      { key: 'progress_dashboard', label: 'Progress Dashboard' },
      { key: 'dashboard', label: 'Dashboard' },
    ];

    const leaderBoardChildren = [
      { key: 'leaderboard_leader', label: 'Leader List' },
      { key: 'leaderboard_naughty', label: 'Naughty List' },
    ];

    const features = [
      { key: 'feedback', label: 'Feedback', children: feedbackChildren },
      { key: 'leaderboards', label: 'Leaderboards', children: leaderBoardChildren },
      { key: 'workspace', label: 'Workspace' },
      { key: 'outcomes', label: 'Outcomes' },
      { key: 'pipeline', label: 'Pipeline' },
      { key: 'forecast', label: 'Forecast' },
      { key: 'performance', label: 'Performance' },
      { key: 'nominations', label: 'Nominations', tip: (<p><strong>Nominations</strong> Enable TruVoice Nominations Integration for this organization</p>) },
    ];

    return (
      <Panel
        eventKey="modules"
      >
        {this.renderPanelHeader('TruVoice Automation Modules', this.state.activeKey === 'modules')}
        <Panel.Body collapsible>
          <div className={styles.features}>
            {features.map((feature) => {
              const hasChildren = feature.children && feature.children.length > 0;
              const selected = selectedFeatures[feature.key] === true && !hasChildren;
              let comp = (<span>{feature.label}</span>);
              if (feature.tip) {
                const popover = (
                  <Popover id={`pop-feature-${feature.key}`}>{feature.tip}</Popover>
                );
                comp = (
                  <OverlayTrigger placement="right" overlay={popover}>
                    <ControlLabel style={{ cursor }}>
                      {comp}
                      &nbsp;
                      <Fa name="info-circle" className="text-active" />
                    </ControlLabel>
                  </OverlayTrigger>
                );
              } else {
                comp = (
                  <ControlLabel style={{ cursor }}>
                    {comp}
                  </ControlLabel>
                );
              }

              let formElement = null;
              if (hasChildren) {
                let selectedCount = 0;
                const childrenFormElements = (
                  <div className={styles.subFeatures}>
                    {feature.children.map((subElement) => {
                      const subSelected = selectedFeatures[subElement.key] === true;
                      if (subSelected) {
                        selectedCount += 1;
                      }
                      return (
                        <FormGroup
                          key={subElement.key}
                          style={{ cursor, margin: 0 }}
                          onClick={() => {
                            this.onToggleView(subElement.key);
                          }}
                        >
                          <Fa
                            name={subSelected ? 'check-square' : 'square-o'}
                            className={subSelected ? 'text-success' : ''}
                          />
                          &nbsp;
                          <ControlLabel style={{ cursor }}>
                            {subElement.label}
                          </ControlLabel>
                        </FormGroup>
                      );
                    })}
                  </div>
                );
                const masterSelectedAll = selectedCount === feature.children.length;
                const masterSelectedSome = selectedCount > 0;
                let masterName = 'square-o';
                if (masterSelectedAll) {
                  masterName = 'check-square';
                } else if (masterSelectedSome) {
                  masterName = 'minus-square';
                }
                formElement = (
                  <FormGroup
                    key={feature.key}
                    style={{ margin: 0 }}
                  >
                    <div
                      role="group"
                      style={{ cursor }}
                      onClick={() => {
                        this.onToggleGroupView(feature.children);
                      }}
                    >
                      <Fa
                        name={masterName}
                        className={masterSelectedSome ? 'text-success' : ''}
                      />
                      &nbsp;
                      {comp}
                    </div>
                    {childrenFormElements}
                  </FormGroup>
                );
              } else {
                formElement = (
                  <FormGroup
                    key={feature.key}
                    style={{ cursor, margin: 0 }}
                    onClick={() => {
                      this.onToggleView(feature.key);
                    }}
                  >
                    <Fa
                      name={selected ? 'check-square' : 'square-o'}
                      className={selected ? 'text-success' : ''}
                    />
                    &nbsp;
                    {comp}
                  </FormGroup>
                );
              }

              return formElement;
            })}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderSearchLimit() {
    return (
      <Panel
        eventKey="searchLimit"
      >
        {this.renderPanelHeader('Search Settings', this.state.activeKey === 'searchLimit')}
        <Panel.Body collapsible>
          <Field name="search_limit" type="text" component={this.renderField} componentClass="number" label="Search Limit" />
        </Panel.Body>
      </Panel>
    );
  }

  renderExportOptions() {
    const {
      submitting, selectedExportCrmUrls,
    } = this.props;
    const cursor = submitting ? 'not-allowed' : 'pointer';
    
    const popover = (
      <Popover id="org-export-crm-urls-tooltip">
        <p>
          <strong>Export Hyperlinks in Excel</strong> will include CRM hyperlinks to Opportunities, Sales Reps, Accounts,... when exporting data from TruVoice Automation.
        </p>
      </Popover>
    );


    return (
      <Panel
        eventKey="exportOptions"
      >
        {this.renderPanelHeader('Export Settings', this.state.activeKey === 'exportOptions')}
        <Panel.Body collapsible>
          <div>
            Export Hyperlinks in Excel:
            {' '}
            <OverlayTrigger placement="right" overlay={popover}>
              <ControlLabel style={{ cursor }}>
                <Fa name="info-circle" className="text-active" />
              </ControlLabel>
            </OverlayTrigger>
            {' '}
            <Toggle
              onClick={this.onToggleExportCrmUrls}
              on={<span>Enabled</span>}
              off={<span>Disabled</span>}
              size="xs"
              onstyle="success"
              active={selectedExportCrmUrls === true}
            />
          </div>

          
        </Panel.Body>
      </Panel>
    );
  }

  renderMailService() {
    const options = [
      { value: 'postmark', label: 'PostMark' },
      { value: 'sendgrid', label: 'SendGrid' },
    ];
    return (
      <Panel
        eventKey="mailService"
      >
        {this.renderPanelHeader('Mail Service', this.state.activeKey === 'mailService')}
        <Panel.Body collapsible>
          <Field name="mail_service" options={options} componentClass="select" component={this.renderField} label="Mail Service" />
        </Panel.Body>
      </Panel>
    );
  }


  renderSyncLimit() {
    const { selectedSyncLimit } = this.props;
    const options = reduce([5, 6, 7, 8, 9, 10], (items, year) => {
      items.push({
        value: year,
        label: `${year} Years`,
      })
      return items;
    }, []);

    return (
      <div>
        <Field name="sync_limit" options={options} componentClass="select" component={this.renderField} label="Sync Limit" />
        {selectedSyncLimit > 0 &&
          <div>
            TruVoice Automation will pull opportunities data within {selectedSyncLimit} years.
          </div>
        }
      </div>
    );
  }



  renderPanelHeader(label, active) {
    return (
      <Panel.Heading>
        <Panel.Title>
          <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
            <table>
              <tbody>
                <tr>
                  <td width="99%" className="text-active">
                    {label}
                  </td>
                  <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={active ? 'caret-up' : 'caret-down'} /></td>
                </tr>
              </tbody>
            </table>
          </Panel.Toggle>
        </Panel.Title>
      </Panel.Heading>
    );
  }

  renderOrganizationType() {
    const {
      submitting, selectedType,
    } = this.props;
    const cursor = submitting ? 'not-allowed' : 'pointer';

    const isSalesforce = selectedType === 'force';
    const isAzure = selectedType === 'azure';
    const isHubspot = selectedType === 'hubspot';

    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title>Organization Type</Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <div className="row">
            <div className="col-xs-4">
              <FormGroup
                style={{ cursor, margin: '0 0 0 10px' }}
                onClick={() => {
                  this.props.change('type', 'force');
                }}
              >
                <Fa
                  name={isSalesforce ? 'check-circle' : 'circle-o'}
                  className={isSalesforce ? 'text-success' : ''}
                />
                &nbsp;
                <ControlLabel style={{ cursor }}>
                  Salesforce
                </ControlLabel>
              </FormGroup>
            </div>
            
            {process.env.REACT_APP_AZURE_ENABLED &&
              <div className="col-xs-4">
                <FormGroup
                  style={{ cursor, margin: '0 0 0 10px' }}
                  onClick={() => {
                    this.props.change('type', 'azure');
                  }}
                >
                  <Fa
                    name={isAzure ? 'check-circle' : 'circle-o'}
                    className={isAzure ? 'text-success' : ''}
                  />
                  &nbsp;
                  <ControlLabel style={{ cursor }}>
                    Microsoft Dynamics
                  </ControlLabel>
                </FormGroup>
              </div>
            }

            {process.env.REACT_APP_HUBSPOT_ENABLED &&
              <div className="col-xs-4">
                <FormGroup
                  style={{ cursor, margin: '0 0 0 10px' }}
                  onClick={() => {
                    this.props.change('type', 'hubspot');
                  }}
                >
                  <Fa
                    name={isHubspot ? 'check-circle' : 'circle-o'}
                    className={isHubspot ? 'text-success' : ''}
                  />
                  &nbsp;
                  <ControlLabel style={{ cursor }}>
                    Hubspot
                  </ControlLabel>
                </FormGroup>
              </div>
            }
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderModal() {
    const {
      handleSubmit, submitting, syncType, organization,
      autoEmail, loginUser, tier, syncing,
      selectedContactGDPRCompliance,
      selectedSalesRepGDPRCompliance,
      sellerReasonsEnabled, sellerReasonsFirst,
      sellerReasonsPublic,
      selectedBypassRequestFeedbackThrottle,
      selectedOrganizationId,
      selectedManualSync,
      selectedEnabled,
    } = this.props;
    const { activeKey } = this.state;
    const isNew = organization._id === undefined;
    const isSuperAdmin = loginUser.role === 'superadmin';
    const isAdmin = loginUser.role === 'admin' || isSuperAdmin;

    const clientIds = organization.tru_voice_clients || [];
    const cursor = submitting ? 'not-allowed' : 'pointer';

    const idChanged = selectedOrganizationId !== organization.organization_id && organization.organization_id;

    const popoverAutoEmail = (
      <Popover id="org-email-tooltip">
        <p>
          <strong>Auto Emails</strong> Automatically
          send TruVoice Automation welcome emails to new sales representative users.
        </p>
      </Popover>
    );

    const popoverSallerReasons = (
      <Popover id="org-seller-reason-tooltip">
        <p>
          <strong>Seller Reasons</strong>: When on, enables the client&rsquo;s sales reps to provide seller reasons for opportunity outcomes.
        </p>
      </Popover>
    );
    

    const selectedContactOption = find(allContactGDPROptions, { value: selectedContactGDPRCompliance }) || first(allContactGDPROptions);
    const selectedSalesRepOption = find(allSalesRepGDPROptions, { value: selectedSalesRepGDPRCompliance }) || first(allSalesRepGDPROptions);

    return (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          {isNew && <Modal.Title>Add New Organization</Modal.Title>}
          {!isNew && <Modal.Title>
            {organization.is_demo && <span>Edit Demo Organization</span>}
            {!organization.is_demo && <span>Edit Organization</span>}
          </Modal.Title>}
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            {isNew && this.renderOrganizationType()}
            <Panel>
              <Panel.Body>
                <Field name="display_name" label="Organization Name" type="text" component={this.renderField} placeholder="Organization Name" />
                {!organization.is_demo &&
                  <div>
                    <Field name="organization_id" label="CRM ID" type="text" component={this.renderField} placeholder="CRM ID" />
                    {idChanged &&
                      <div className="alert alert-danger">
                        <Fa name="exclamation-triangle" /> You are about to change the CRM ID. This cannot be undone.
                      </div>
                    }
                  </div>
                }
                {isSuperAdmin && !organization.is_demo && !isNew &&
                  <div>
                    <p />
                    <ControlLabel style={{ cursor }}>Client Status</ControlLabel>
                    {' '}
                    <Toggle
                      onClick={this.onToggleOrganizationStatus}
                      on={<span>Active</span>}
                      off={<span>Inactive</span>}
                      size="xs"
                      onstyle="success"
                      offstyle="danger"
                      active={selectedEnabled === true}
                    />
                    <AuditLog key={organization._id} label="Client Status" organization={organization} subjectId={organization._id} type="organizationStatusChanged" />
                  </div>
                }
              </Panel.Body>
            </Panel>

            
            
            {isAdmin && !organization.is_demo && false && <div className="row">
              <FormGroup
                className="col-sm-6"
                style={{ cursor }}
                onClick={() => {
                  if (!submitting) {
                    this.onToggleTier();
                  }
                }}
              >
                <Fa
                  name={tier === 'premium' ? 'check-square' : 'square-o'}
                  className={tier === 'premium' ? 'text-success' : ''}
                />
                &nbsp;
                <ControlLabel style={{ cursor }}>Premium Access Tier</ControlLabel>
              </FormGroup>
            </div>}

            <PanelGroup
              accordion
              id="organization-settings"
              activeKey={activeKey}
              onSelect={this.handlePanelSelect}
            >
              {!organization.is_demo &&
                <Panel
                  eventKey="syncSettings"
                >
                  {this.renderPanelHeader('Sync Settings', activeKey === 'syncSettings')}
                  <Panel.Body collapsible>
                    <div>
                      Sync Type:
                      {' '}
                      <Toggle
                        onClick={this.onToggleSyncType}
                        on={<span>Detailed</span>}
                        off={<span>Summary</span>}
                        size="xs"
                        onstyle="success"
                        active={syncType === 'detailed'}
                      />
                    </div>
                    <p />
                    {syncType === 'summary' &&
                      <div>
                        Summary data does not include ANY data that can be used to identify
                        an account, opportunity or a sales representative.
                      </div>
                    }
                    {syncType === 'detailed' &&
                      <div>
                        Detailed data collects sales representative names, opportunity names,
                        and account names to allow for deeper analysis of your organization&rsquo;s data
                      </div>
                    }


                    {isAdmin && !organization.is_demo && 
                      <div>
                        <hr />
                        <div>
                          Manual Sync:
                          {' '}
                          <Toggle
                            onClick={this.onToggleManualSync}
                            on={<span>On</span>}
                            off={<span>Off</span>}
                            size="xs"
                            onstyle="success"
                            offstyle="warning"
                            active={selectedManualSync}
                          />
                        </div>
                        <div>
                          Manual Sync will allow syncing data using CSV files instead of direct pulling data from CRM.
                        </div>
                        <p />
                      </div>
                    }
                    <hr />
                    {this.renderSyncLimit()}

                  </Panel.Body>
                </Panel>
              }

              {isAdmin && !organization.is_demo &&
                <Panel
                  eventKey="inviatationEmails"
                >
                  {this.renderPanelHeader('Invitation Emails', activeKey === 'inviatationEmails')}
                  <Panel.Body collapsible>
                    <FormGroup
                      className="col-sm-6"
                      style={{ cursor }}
                      onClick={() => {
                        if (!submitting) {
                          this.onToggleAutoEmail();
                        }
                      }}
                    >
                      <Fa
                        name={autoEmail ? 'check-square' : 'square-o'}
                        className={autoEmail ? 'text-success' : ''}
                      />
                      &nbsp;
                      <OverlayTrigger placement="right" overlay={popoverAutoEmail}>
                        <ControlLabel style={{ cursor }}>
                          Auto Emails
                          &nbsp;
                          <Fa name="info-circle" className="text-active" />
                        </ControlLabel>
                      </OverlayTrigger>
                    </FormGroup>
                  </Panel.Body>
                </Panel>
              }


              {this.renderViewPermissions()}
              {this.renderSearchLimit()}
              {this.renderExportOptions()}
              {!organization.is_demo &&
                <Panel
                  eventKey="sellerReasons"
                >
                  {this.renderPanelHeader('Seller Reasons', activeKey === 'sellerReasons')}
                  <Panel.Body collapsible>
                    <div>
                      <div>
                        <ControlLabel>Seller Reasons:</ControlLabel>
                        &nbsp;
                        <Toggle
                          onClick={this.onToggleSellerReasons}
                          on={<span>Enabled</span>}
                          off={<span>Disabled</span>}
                          size="xs"
                          onstyle="success"
                          active={sellerReasonsEnabled}
                        />
                        &nbsp;
                        <OverlayTrigger placement="right" overlay={popoverSallerReasons}>
                          <Fa name="info-circle" className="text-active" />
                        </OverlayTrigger>
                      </div>
                      {sellerReasonsEnabled &&
                        <div className="panel-body animated slideDownIn">
                          <ControlLabel>Request Order:</ControlLabel>
                          <FormGroup
                            style={{ cursor, margin: '0 0 0 10px' }}
                            onClick={() => {
                              this.props.change('seller_reasons_first', false);
                            }}
                          >
                            <Fa
                              name={!sellerReasonsFirst ? 'check-circle' : 'circle-o'}
                              className={!sellerReasonsFirst ? 'text-success' : ''}
                            />
                            &nbsp;
                            <ControlLabel style={{ cursor }}>
                              Request Feedback first
                            </ControlLabel>
                          </FormGroup>

                          <FormGroup
                            style={{ cursor, margin: '0 0 0 10px' }}
                            onClick={() => {
                              this.props.change('seller_reasons_first', true);
                            }}
                          >
                            <Fa
                              name={sellerReasonsFirst ? 'check-circle' : 'circle-o'}
                              className={sellerReasonsFirst ? 'text-success' : ''}
                            />
                            &nbsp;
                            <ControlLabel style={{ cursor }}>
                              Seller Reasons first
                            </ControlLabel>
                          </FormGroup>
                          <p />
                          <ControlLabel>Enabled For:</ControlLabel>
                          <FormGroup
                            style={{ cursor, margin: '0 0 0 10px' }}
                            onClick={() => {
                              this.props.change('seller_reasons_public', false);
                            }}
                          >
                            <Fa
                              name={!sellerReasonsPublic ? 'check-circle' : 'circle-o'}
                              className={!sellerReasonsPublic ? 'text-success' : ''}
                            />
                            &nbsp;
                            <ControlLabel style={{ cursor }}>
                              Opportunity Owner
                            </ControlLabel>
                          </FormGroup>

                          <FormGroup
                            style={{ cursor, margin: '0 0 0 10px' }}
                            onClick={() => {
                              this.props.change('seller_reasons_public', true);
                            }}
                          >
                            <Fa
                              name={sellerReasonsPublic ? 'check-circle' : 'circle-o'}
                              className={sellerReasonsPublic ? 'text-success' : ''}
                            />
                            &nbsp;
                            <ControlLabel style={{ cursor }}>
                              Anyone
                            </ControlLabel>
                          </FormGroup>
                        </div>
                      }
                    </div>
                  </Panel.Body>
                </Panel>
              }

              {isNew &&
                <Panel
                  eventKey="contactGDPR"
                >
                  {this.renderPanelHeader('Contact GDPR Compliance Settings', activeKey === 'contactGDPR')}
                  <Panel.Body collapsible>
                    <table className="table table-condensed table-borderless">
                      <tbody>
                        {allContactGDPROptions.map((opt) => {
                          const isChecked = selectedContactOption !== undefined && opt.value === selectedContactOption.value;
                          let cls = isChecked ? 'text-success' : '';
                          let faName = isChecked ? 'check-circle' : 'circle-o';
                          let spin = false;
                          if (submitting) {
                            spin = true;
                            cls = 'text-muted';
                            if (isChecked) {
                              faName = 'spinner';
                            }
                          }
                          return (
                            <tr
                              style={{ cursor }}
                              key={opt.value}
                              onClick={() => {
                                if (!submitting) {
                                  this.selectContactGDPR(opt.value);
                                }
                              }}
                            >
                              <td className="text-right" style={{ width: 40 }}>
                                <Fa
                                  name={faName}
                                  className={cls}
                                  spin={spin}
                                />
                              </td>
                              <td>
                                <ControlLabel style={{ cursor }}>
                                  <strong>{opt.label}</strong>
                                </ControlLabel>
                                <Collapse in={isChecked}>
                                  <div>
                                    <small>{opt.text}</small>
                                  </div>
                                </Collapse>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Panel.Body>
                </Panel>
              }
              {isNew &&
                <Panel
                  eventKey="salesRepsGDPR"
                >
                  {this.renderPanelHeader('Sales Rep GDPR Compliance Settings', activeKey === 'salesRepsGDPR')}
                  <Panel.Body collapsible>
                    <table className="table table-condensed table-borderless">
                      <tbody>
                        {allSalesRepGDPROptions.map((opt) => {
                          const isChecked = selectedSalesRepOption !== undefined && opt.value === selectedSalesRepOption.value;
                          let cls = isChecked ? 'text-success' : '';
                          let faName = isChecked ? 'check-circle' : 'circle-o';
                          let spin = false;
                          if (submitting) {
                            spin = true;
                            cls = 'text-muted';
                            if (isChecked) {
                              faName = 'spinner';
                            }
                          }
                          return (
                            <tr
                              style={{ cursor }}
                              key={opt.value}
                              onClick={() => {
                                if (!submitting) {
                                  this.selectSalesRepGDPR(opt.value);
                                }
                              }}
                            >
                              <td className="text-right" style={{ width: 40 }}>
                                <Fa
                                  name={faName}
                                  className={cls}
                                  spin={spin}
                                />
                              </td>
                              <td>
                                <ControlLabel style={{ cursor }}>
                                  <strong>{opt.label}</strong>
                                </ControlLabel>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Panel.Body>
                </Panel>
              }

              {this.renderMailService()}
            </PanelGroup>
            

            {isAdmin && !isNew && !organization.is_demo && <FormGroup>
              <ControlLabel>Syncing Status:</ControlLabel>
              &nbsp;
              <Toggle
                onClick={this.onToggleSyncing}
                on={<span>Syncing</span>}
                off={<span>Idle</span>}
                size="xs"
                onstyle="success"
                active={syncing}
              />
            </FormGroup>}
            
            
            {isAdmin && !isNew && !organization.is_demo && <FormGroup>
              <ControlLabel>Request Feedback Throttling:</ControlLabel>
              &nbsp;
              <Toggle
                onClick={this.onToggleThrottle}
                on={<span>Off</span>}
                off={<span>On</span>}
                size="xs"
                offstyle="success"
                onstyle="warning"
                active={selectedBypassRequestFeedbackThrottle}
              />
              <div className={selectedBypassRequestFeedbackThrottle ? 'text-warning' : 'text-success'}>
                <Fa name={selectedBypassRequestFeedbackThrottle ? 'exclamation-triangle' : 'check-circle'} />
                {' '}
                {selectedBypassRequestFeedbackThrottle === true && <span>Feedback requests will NOT be throttled</span>}
                {selectedBypassRequestFeedbackThrottle !== true && <span>Feedback requests will be throttled</span>}
              </div>
            </FormGroup>}
          </Modal.Body>
          <Modal.Footer className="clearfix">
            <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>

            {isNew && <Button className="pull-right" bsStyle="primary" disabled={submitting} type="submit">
              {!submitting && <span><Fa name="plus" /> Add</span>}
              {submitting && <span><Fa name="spinner" spin /> Adding</span>}
            </Button>}
            {!isNew && idChanged && !submitting &&
              <ConfirmButton
                confirmStyle="warning"
                onConfirm={this.confirmChange}
              >
                <span><Fa name="pencil" /> Update</span>
              </ConfirmButton>
            }
            {!isNew && idChanged && submitting &&
              <Button className="pull-right" bsStyle="primary" disabled={submitting} type="submit">
                <span><Fa name="spinner" spin /> Updating</span>
              </Button>
            }
            {!isNew && !idChanged && <Button className="pull-right" bsStyle="primary" disabled={submitting} type="submit">
              {!submitting && <span><Fa name="pencil" /> Update</span>}
              {submitting && <span><Fa name="spinner" spin /> Updating</span>}
            </Button>}
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const { organization, disabled, size } = this.props;
    const isNew = organization._id === undefined;
    return (
      <span>
        {this.renderModal()}
        <Button disabled={disabled} bsSize={size} onClick={this.open} bsStyle="primary">
          {isNew && <span><Fa name="plus" /> Add Organization</span>}
          {!isNew && <span><Fa name="edit" /> Edit</span>}
        </Button>
      </span>
    );
  }
}

const selector = formValueSelector('addOrganization'); // <-- same as form name
// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const initialValues = { ...ownProps.organization };
  return {
    initialValues,
    syncType: selector(state, 'sync_type'),
    tier: selector(state, 'tier'),
    autoEmail: selector(state, 'auto_send_welcome_email'),
    syncing: selector(state, 'syncing'),
    selectedFeatures: selector(state, 'features'),
    selectedContactGDPRCompliance: selector(state, 'contact_gdpr_compliance'),
    selectedSalesRepGDPRCompliance: selector(state, 'sales_rep_gdpr_compliance'),
    sellerReasonsEnabled: selector(state, 'seller_reasons_enabled'),
    sellerReasonsFirst: selector(state, 'seller_reasons_first'),
    sellerReasonsPublic: selector(state, 'seller_reasons_public'),
    selectedOrganizationId: selector(state, 'organization_id'),
    selectedBypassRequestFeedbackThrottle: selector(state, 'bypass_request_feedback_throttle'),
    selectedManualSync: selector(state, 'manual_sync'),
    selectedEnabled: selector(state, 'enabled'),
    selectedSyncLimit: selector(state, 'sync_limit'),
    formValues: getFormValues('addOrganization')(state),
    selectedType: selector(state, 'type'),
    selectedExportCrmUrls: selector(state, 'export_crm_urls'),
    loginUser: getUser(state),
  };
}

AddOrganizationButton.propTypes = {
  initialize: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  change: PropTypes.func,
  syncType: PropTypes.string,
  size: PropTypes.string,
  tier: PropTypes.string,
  autoEmail: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    is_demo: PropTypes.bool,
    organization_id: PropTypes.string,
  }).isRequired,
  loginUser: PropTypes.shape({}).isRequired,
  selectedContactGDPRCompliance: PropTypes.string,
  selectedSalesRepGDPRCompliance: PropTypes.string,
  sellerReasonsEnabled: PropTypes.bool,
  sellerReasonsFirst: PropTypes.bool,
  selectedType: PropTypes.string,
  selectedSyncLimit: PropTypes.number,
  syncing: PropTypes.bool,
  selectedFeatures: PropTypes.shape({
    nominations: PropTypes.bool,
  }),
  showForm: PropTypes.bool,
  onModalClose: PropTypes.func,
  sellerReasonsPublic: PropTypes.bool,
  formValues: PropTypes.shape({}),
  selectedOrganizationId: PropTypes.string,
  selectedBypassRequestFeedbackThrottle: PropTypes.bool,
  selectedManualSync: PropTypes.bool,
  selectedEnabled: PropTypes.bool,
  selectedExportCrmUrls: PropTypes.bool,
};
AddOrganizationButton.defaultProps = {
  onAdd: () => {},
  onUpdate: () => {},
  disabled: false,
  size: null,
  organization: {
    sync_type: 'detailed',
    tier: 'basic',
    type: 'force',
    sync_limit: 5,
    syncing: false,
  },
  selectedFeatures: {
    nominations: false,
  },
  showForm: false,
  sellerReasonsEnabled: false,
  sellerReasonsFirst: false,
  sellerReasonsPublic: false,
  selectedSyncLimit: 5,
  selectedType: 'force',
  formValues: {},
  selectedOrganizationId: null,
  onModalClose: () => {},
  selectedBypassRequestFeedbackThrottle: true,
  selectedManualSync: false,
  selectedEnabled: true,
  selectedExportCrmUrls: false,
};

const AddOrganizationForm = reduxForm({
  form: 'addOrganization',
})(AddOrganizationButton);

export default connect(mapStateToProps)(AddOrganizationForm);
